import React, { useState, useEffect } from 'react';
import * as ReactDOM from "react-dom";
import { Button, Row, Col } from "reactstrap";

interface Props {
    amount: number;
    repaymentTime: number;
}

const ApplicationDeclined: React.FunctionComponent<Props> = props => {

    const [loans, setloans] = useState([]);

    useEffect(() => {
        const loadLoans = async () => {
            fetch("/api/loans/" + props.amount)
                .then(data => { return data.json() })
                .then(res => {
                    setloans(res)
                })
        };
        loadLoans();
        window.scrollTo(0, 0)

    }, [])

    const drawLoans = () => {
        let loansHtml = [];
        for (let i = 0; i < loans.length; i++) {
            let loan = loans[i];
            loansHtml.push(
                <Col key={i} className="loan col-lg-4 col-12">
                    <div className="loan-container-alternative">
                        <div className=" text-center">
                            {loan.ImageUrl != null && <h4 className="altLoanLogo"> <img className="logo" src={loan.ImageUrl} alt={loan.Headline} />
                            </h4>}
                            {loan.ImageUrl == null && <h4 className="altLoanLogo">{loan.Headline}
                            </h4>}
                        </div>
                        <Row className="loan-text ">
                            <div className="col-4 text-left"><span><strong>Lånebelopp</strong></span></div>
                            <div className="col-8 text-right"><span>{loan.MinLoanAmount.toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(",", ".")} - {loan.MaxLoanAmount.toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(",", ".")} kr</span></div>
                        </Row>
                        <Row className="loan-text ">
                            <div className="col-4 text-left"><span><strong>Återbetalningstid</strong></span></div>
                            <div className="col-8 text-right"><span>  {loan.MinDuration && loan.MinDuration}{loan.MinDuration && loan.MaxDuration && ' -'}  {loan.MaxDuration && loan.MaxDuration}{loan.TimeUnit}</span></div>
                        </Row>
                        <Row className="loan-text ">
                            <div className="col-5 text-left"><span><strong>Rånta/år</strong></span></div>
                            {loan.Mininterest != 0 &&
                                <div className="col-7 text-right"><span>{loan.MinInterest && loan.MinInterest}{loan.MinInterest && loan.MaxInterest && ' -'}  {loan.MaxInterest && loan.MaxInterest}%</span></div>
                            }
                            {loan.Mininterest > 0 &&
                                <div className="col-7 text-right"><span>{loan.MaxInterest}%</span></div>
                            }

                        </Row>
                        <div className="d-flex">
                            <a href={loan.TrackingUrl} target="_blank">ANSÖK</a>
                        </div>
                        <div className="example-text">Räkneexempel: Låna: {loan.ExampleAmount} kr. Löptid: {loan.ExampleMonths} månader. Avgifter: {loan.ExampleStartCosts} kr. Nominell ränta: {loan.ExampleInterest} %. Effektiv årsränta: {loan.ExampleAAop} %. Kostnad: {loan.ExampleMonthlyPay} kr/månad. Totalt: {loan.ExampleTotalPayback} kr.{loan.ExtraExampleInfo}
                            </div>
                    </div>
                </Col>
            );
        };
        return loansHtml
    }


    return (
        <div className="loan-container" id="response">
            <div className="content">
                <div className="top-strip-indicator"></div>
                <h2 className="text-primary pt-3 pb-5">Tack för din ansökning hos Lendsafe</h2>
                <div className="text-center pb-4">

                    <p>
                        Din ansökning har tyvärr avvisats.<br /><br />
                        Vi rekommenderar dessa {loans.length} lån till dig utifrån ditt önskade lånebelopp på {props.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} kr med en återbetalning på {props.repaymentTime} år.
          </p>

                </div>
                <Row >
                    {drawLoans()}    
                    <Col className=" col-12 text-center pt-1" style={{ marginTop: "20px" }}>
                        <p className="d-block">
                            <strong>Tips:</strong> Kom ihåg att du kan öka dina chanser för ett lån om du ansöker hos flera. 
                  </p>
                        </Col>
                </Row>
            </div>
        </div>
        )
    
}

export default ApplicationDeclined;